import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import lefticon from "../images/Leftnew.svg";
import img1 from "../images/Google.svg";
import img2 from "../images/Apple.svg";
import img3 from "../images/Facebook.svg";

export default function LoginPage() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        "https://app.metabolytics.ai/simulator-backend/healthcare/login",
        formData
      );
      const { token } = res.data;
      localStorage.setItem("token", token);
      alert("Login Successful!");

      const userDetailsRes = await axios.get(
        `https://app.metabolytics.ai/simulator-backend/healthcare/user?email=${formData.email}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const { firstName, lastName } = userDetailsRes.data;
      const decoded = jwtDecode(token);

      if (decoded.role === "Admin") {
        navigate("/admin-dashboard");
      } else {
        navigate(
          `/dashboard-page?name=${encodeURIComponent(
            firstName + " " + lastName
          )}`
        );
      }
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "Login failed. Please try again."
      );
    }
  };

  return (
    <div className="Login-container-bg">
      <div className="Login-container-main">
        <div
          className="icon-container-new"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <img src={lefticon} alt="Back" />
        </div>
        <h3>Login</h3>

        {/* Social Login Options */}
        <div className="social-login google">
          <a href="">
            <span>
              <img src={img1} alt="Google" />
            </span>
            <span>Sign in with Google</span>
          </a>
        </div>
        <div className="social-login apple">
          <a href="">
            <span>
              <img src={img2} alt="Apple" />
            </span>
            <span>Sign in with Apple</span>
          </a>
        </div>
        <div className="social-login facebook">
          <a href="">
            <span>
              <img src={img3} alt="Facebook" />
            </span>
            <span>Sign in with Facebook</span>
          </a>
        </div>

        <div className="divider">
          <h4>OR</h4>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit}>
          {errorMessage && <div className="error-message">{errorMessage}</div>}

          <div className="input-container-new email">
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="Signup-input password-input-container">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
            />
            <span
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </span>
            {errors.password && (
              <span className="error-message">{errors.password}</span>
            )}
          </div>

          <div className="forgot-password">
            <h5 onClick={handleForgotPassword}>Forgot Password?</h5>
          </div>

          <div className="login-button-container">
            <button type="submit">Login</button>
          </div>
        </form>

        <div className="signup-link">
          <p>
            Don't have an account?{" "}
            <span onClick={() => navigate("/signup")}>Sign up</span>
          </p>
        </div>
      </div>
    </div>
  );
}
